<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de {{'Consorcio' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canAdd || canEdit">

        <form [formGroup]="formGroup">

          <!-- DATOS DEL CONSORCIO -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
    
            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="200">
                  <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Razón Social*</mat-label>
                  <input matInput formControlName="RazonSocial" (keyup.enter)="onGuardar()" maxlength="200">
                  <mat-error *ngIf="!formGroup.controls['RazonSocial'].valid && formGroup.controls['RazonSocial'].touched">
                    {{ getErrorRazonSocial() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="formGroup?.get('TipoDocumentoId').value == null">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Tipo de Documento*</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoDocumentoId">
                    <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['TipoDocumentoId'].valid && formGroup.controls['TipoDocumentoId'].touched">
                    {{ getErrorTipoDocumento() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>CUIT*</mat-label>
                  <input matInput type="number" formControlName="NroDocumento" (keyup.enter)="onGuardar()" maxlength="50">
                  <mat-error *ngIf="!formGroup.controls['NroDocumento'].valid && formGroup.controls['NroDocumento'].touched">
                    {{ getErrorNroDocumento() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isPaisSearching">País</mat-label>
                  <mat-label *ngIf="isPaisSearching">Cargando...</mat-label>
                  <mat-select formControlName="PaisId" (selectionChange)="onPaisSelect()">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of paisList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isProvinciaSearching">Provincia</mat-label>
                  <mat-label *ngIf="isProvinciaSearching">Cargando...</mat-label>
                  <mat-select formControlName="ProvinciaId">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of provinciaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Dirección</mat-label>
                  <input matInput formControlName="Direccion" (keyup.enter)="onGuardar()" maxlength="200">
                  <mat-error *ngIf="!formGroup.controls['Direccion'].valid && formGroup.controls['Direccion'].touched">
                    {{ getErrorDireccion() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Código Postal</mat-label>
                  <input matInput formControlName="CodigoPostal" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['CodigoPostal'].valid && formGroup.controls['CodigoPostal'].touched">
                    {{ getErrorCodigoPostal() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Teléfono</mat-label>
                  <input matInput formControlName="Telefono" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error *ngIf="!formGroup.controls['Telefono'].valid && formGroup.controls['Telefono'].touched">
                    {{ getErrorTelefono() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="Email" type="email" (keyup.enter)="onGuardar()" maxlength="255">
                  <mat-error *ngIf="!formGroup.controls['Email'].valid && formGroup.controls['Email'].touched">
                    {{ getErrorMail() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoResponsableIvaSearching">Tipo Responsable IVA</mat-label>
                  <mat-label *ngIf="isTipoResponsableIvaSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoResponsableIvaId">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of tipoResponsableIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <mat-checkbox [(ngModel)]="item.Activo" [ngModelOptions]="{standalone: true}" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox> 
              </div>

            </div>

          </mat-expansion-panel>

          <!-- Cuentas de consorcio  -->
          <ng-container *ngIf="canViewCuenta && item?.Id > 0">
          
            <br/>
            <!-- Cuentas de consorcio  -->
            <mat-expansion-panel [expanded]="true">
  
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-right: 5px;">account_balance_wallet</mat-icon> Cuentas
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
                
              </mat-expansion-panel-header>
  
              <form [formGroup]="cuentaBancariaFormGroup" *ngIf="canAddCuenta || canEditCuenta">
  
                <div fxLayout="row stretch" fxLayout.xs="column">
  
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>CBU/CVU*</mat-label>
                      <input matInput formControlName="ClaveBancaria"  maxlength="100">
                      <mat-error
                        *ngIf="!cuentaBancariaFormGroup.controls['ClaveBancaria'].valid && cuentaBancariaFormGroup.controls['ClaveBancaria'].touched">
                        {{ getCuentaErrorClaveBancaria() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Alias*</mat-label>
                      <input matInput formControlName="Alias" maxlength="100">
                      <mat-error
                        *ngIf="!cuentaBancariaFormGroup.controls['Alias'].valid && cuentaBancariaFormGroup.controls['Alias'].touched">
                        {{ getCuentaErrorAlias() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isBancoSerching">Banco</mat-label>
                      <mat-label *ngIf="isBancoSerching">Cargando...</mat-label>
                      <mat-select formControlName="BancoId">
                        <mat-option *ngFor="let s of bancoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="!cuentaBancariaFormGroup.controls['BancoId'].valid && cuentaBancariaFormGroup.controls['BancoId'].touched">
                        {{ getCuentaErrorBanco() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Nro. de Cuenta</mat-label>
                      <input matInput formControlName="NumeroCuenta" maxlength="100">
                      <mat-error
                        *ngIf="!cuentaBancariaFormGroup.controls['NumeroCuenta'].valid && cuentaBancariaFormGroup.controls['NumeroCuenta'].touched">
                        {{ getCuentaErrorNumeroCuenta() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
  
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label class="text-label">Titular</mat-label>
                      <input matInput formControlName="Titular" maxlength="100">
                      <mat-error *ngIf="!cuentaBancariaFormGroup.controls['Titular'].valid && cuentaBancariaFormGroup.controls['Titular'].touched">
                        {{ getCuentaErrorTitular() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                      <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                      <mat-select formControlName="MonedaId">
                        <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="!cuentaBancariaFormGroup.controls['MonedaId'].valid && cuentaBancariaFormGroup.controls['MonedaId'].touched">
                        {{ getCuentaErrorMoneda() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
  
                </div>

                <div fxLayout="row-reverse stretch" fxLayout.xs="column">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="onCuentaSave()" [disabled]="isProcessing()" color="primary"
                      class="zb-button">Guardar Cuenta</button>
                  </div>
                </div>
  
              </form>
  
              <div fxLayout="row stretch" fxLayout.xs="column">
                <ejs-grid #cuentasGrid [dataSource]='item.Cuentas' [allowPaging]="true" [allowSorting]="true"
                  [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                  [allowResizing]='true'>
                  <e-columns>
                    <e-column field='BancoNombre' headerText='Banco' width=100></e-column>
                    <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
                    <e-column field='ClaveBancaria' headerText='CBU/CVU' width=100></e-column>
                    <e-column field='Alias' headerText='Alias' width=150></e-column>
                    <e-column field='MonedaCodigo' headerText='Moneda' width=100></e-column>
                    <e-column headerText='Acciones' width=90 *ngIf="canEditCuenta || canDeleteCuenta">
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaView(data)" *ngIf="canEditCuenta"
                          title="Ver cuenta"><i class="fa fa-eye fa-1x"></i>
                        </a>
                        <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaDelete(data)" *ngIf="canDeleteCuenta"
                          title="Eliminar cuenta"><i class="fa fa-trash fa-1x"></i>
                        </a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>
  
            </mat-expansion-panel>
  
          </ng-container>

          <!-- DATOS DE EXPENSAS -->
          <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
            
            <br/>

            <!-- DATOS DE EXPENSAS -->
            <mat-expansion-panel [expanded]="true">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px;">assignment</mat-icon> Datos de Expensas
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
      
              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Interés Vencimiento*</mat-label>
                    <input matInput formControlName="InteresVencimiento" type="number" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Interés Mensual*</mat-label>
                    <input matInput formControlName="InteresMensual" type="number" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isMetodosRedondeoExpensaSearching">Método Redondeo de Expensas*</mat-label>
                    <mat-label *ngIf="isMetodosRedondeoExpensaSearching">Cargando...</mat-label>
                    <mat-select formControlName="MetodoRedondeoExpensa">
                      <mat-option *ngFor="let s of metodosRedondeoExpensaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isConceptosRecargoSearching">Concepto de Recargo*</mat-label>
                    <mat-label *ngIf="isConceptosRecargoSearching">Cargando...</mat-label>
                    <mat-select formControlName="ConceptosRecargo">
                      <mat-option *ngFor="let s of conceptosRecargoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-bottom: 15px;">
                  <mat-checkbox formControlName="ValidarUfTotalPorcentaje" (keyup.enter)="onGuardar()" color="primary">Validar Porcentaje de {{'UnidadFuncional' | translate}}</mat-checkbox> 
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nota Expensas*</mat-label>
                    <textarea matInput formControlName="NotaExpensas" rows="6"></textarea>
                    <mat-error *ngIf="!formGroup.controls['NotaExpensas'].valid && formGroup.controls['NotaExpensas'].touched">
                      {{ getErrorNotaExpensas() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nota en Pie de Expensas*</mat-label>
                    <textarea matInput formControlName="NotaExpensasPie" rows="6"></textarea>
                    <mat-error *ngIf="!formGroup.controls['NotaExpensasPie'].valid && formGroup.controls['NotaExpensasPie'].touched">
                      {{ getErrorNotaExpensasPie() }}
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>

            </mat-expansion-panel>

            <br/>

            <!-- MEDIOS DE PAGO DEL CONSORCIO -->
            <mat-expansion-panel [expanded]="true">

              <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon style="margin-right: 5px;">perm_contact_calendar</mat-icon> Medios de Pago de Expensas
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
              </mat-expansion-panel-header>

              <form [formGroup]="medioPagoFormGroup">

                <div fxLayout="row stretch" fxLayout.xs="column">

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isMedioPagoSearching">Medio de Pago*</mat-label>
                      <mat-label *ngIf="isMedioPagoSearching">Cargando...</mat-label>
                      <mat-select formControlName="MedioPago">
                        <mat-option *ngFor="let s of medioPagoList" [value]="s">{{s.Nombre}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="!medioPagoFormGroup.controls['MedioPago'].valid  && medioPagoFormGroup.controls['MedioPago'].touched">
                        {{ getErrorMedioPago() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Titular</mat-label>
                      <input matInput formControlName="Titular" (keyup.enter)="onMedioPagoAdd()" maxlength="100">
                      <mat-error *ngIf="!medioPagoFormGroup.controls['Titular'].valid && medioPagoFormGroup.controls['Titular'].touched">
                        {{ getErrorTitular() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>CUIT</mat-label>
                      <input matInput formControlName="Cuit" (keyup.enter)="onMedioPagoAdd()" maxlength="100">
                      <mat-error *ngIf="!medioPagoFormGroup.controls['Cuit'].valid && medioPagoFormGroup.controls['Cuit'].touched">
                        {{ getErrorCuit() }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isBancoSerching">Banco</mat-label>
                      <mat-label *ngIf="isBancoSerching">Cargando...</mat-label>
                      <mat-select formControlName="Banco">
                        <mat-option>Ninguno</mat-option>
                        <mat-option *ngFor="let s of bancoList" [value]="s">{{s.Nombre}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="!medioPagoFormGroup.controls['Banco'].valid && medioPagoFormGroup.controls['Banco'].touched">
                        {{ getErrorBanco() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>CBU/CVU</mat-label>
                      <input matInput formControlName="CodigoUnico" (keyup.enter)="onMedioPagoAdd()" maxlength="100">
                      <mat-error *ngIf="!medioPagoFormGroup.controls['CodigoUnico'].valid && medioPagoFormGroup.controls['CodigoUnico'].touched">
                        {{ getErrorCodigoUnico() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Alias</mat-label>
                      <input matInput formControlName="Alias" (keyup.enter)="onMedioPagoAdd()" maxlength="100">
                      <mat-error *ngIf="!medioPagoFormGroup.controls['Alias'].valid && medioPagoFormGroup.controls['Alias'].touched">
                        {{ getErrorAlias() }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Nro. Cuenta</mat-label>
                      <input matInput formControlName="NumeroCuenta" (keyup.enter)="onMedioPagoAdd()" maxlength="100">
                      <mat-error *ngIf="!medioPagoFormGroup.controls['NumeroCuenta'].valid && medioPagoFormGroup.controls['NumeroCuenta'].touched">
                        {{ getErrorNumeroCuenta() }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                </div>

                <div fxLayout="row-reverse stretch" fxLayout.xs="column">
                  <button mat-raised-button (click)="onMedioPagoAdd()" [disabled]="isProcessing()" color="primary" class="zb-button">Guardar Medio Pago</button>
                  <button mat-raised-button (click)="onMedioPagoClean()" [disabled]="isProcessing()" color="warn" class="zb-button">Limpiar</button>
                </div>

              </form>

              <br/>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <ejs-grid #grid [dataSource]='item.MediosPago' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' 
                  [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column field='MedioPagoNombre' headerText='Medio Pago' width=150></e-column>
                    <e-column field='Titular' headerText='Titular' width=100></e-column>
                    <e-column field='Cuit' headerText='CUIT' width=100></e-column>
                    <e-column field='BancoNombre' headerText='Banco' width=100></e-column>
                    <e-column field='CodigoUnico' headerText='CBU/CVU' width=100></e-column>
                    <e-column field='Alias' headerText='Alias' width=100></e-column>
                    <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
                    <e-column headerText='Acciones' width=90>
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 5px" (click)="onMedioPagoView(data)"><i class="fa fa-eye fa-1x"></i></a>
                        <a style="cursor: pointer; margin-right: 5px" (click)="onMedioPagoDelete(data)"><i class="fa fa-trash fa-1x"></i></a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>

            </mat-expansion-panel>

          </ng-container>

        </form>

      </ng-container>

      <ng-container *ngIf="!canAdd && !canEdit">

        <!-- DATOS DEL CONSORCIO -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Razón Social</b>: {{item.RazonSocial}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Documento</b>: {{item.TipoDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>CUIT</b>: {{item.NroDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>País</b>: {{item.Pais}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia</b>: {{item.Provincia}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Dirección</b>: {{item.Direccion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal</b>: {{item.CodigoPostal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Teléfono</b>: {{item.Telefono}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Email</b>: {{item.Email}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Responsable IVA</b>: {{item.TipoResponsableIva}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>
      
        <!-- Cuentas de consorcio -->
        <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlCaja && canViewCuenta">
          
          <br/>

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">account_balance_wallet</mat-icon> Cuentas
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
              
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <ejs-grid #cuentasGrid [dataSource]='item.Cuentas' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='BancoNombre' headerText='Banco' width=100></e-column>
                  <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
                  <e-column field='ClaveBancaria' headerText='CBU/CVU' width=100></e-column>
                  <e-column field='Alias' headerText='Alias' width=150></e-column>
                  <e-column field='MonedaCodigo' headerText='Moneda' width=100></e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canEditCuenta || canDeleteCuenta">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaView(data)" *ngIf="canEditCuenta"
                        title="Ver cuenta"><i class="fa fa-eye fa-1x"></i>
                      </a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

        </ng-container>

        <!-- DATOS DE EXPENSAS -->
        <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">

          <br/>

          <!-- DATOS DE EXPENSAS -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">assignment</mat-icon> Datos de Expensas
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Interés Vencimiento</b>: {{item.InteresVencimiento | number: '1.2-2'}}%</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Interés Mensual</b>: {{item.InteresMensual | number: '1.2-2'}}%</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Método de Redondeo Expensa</b>: {{item.MetodoRedondeoExpensaNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Conceptos Recargo</b>: {{item.ConceptosRecargoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Validar Porcentaje de {{'UnidadFuncional' | translate}}</b>: {{item.ValidarUfTotalPorcentaje ? 'Sí' : 'No'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Nota de Expensas</b>: {{item.NotaExpensas}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Nota de Pie de Expensas</b>: {{item.NotaExpensasPie}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

          <br/>

          <!-- MEDIOS DE PAGO DEL CONSORCIO -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-right: 5px;">perm_contact_calendar</mat-icon> Medios de Pago de Expensas
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <ejs-grid #grid [dataSource]='item.MediosPago' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' 
                [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='MedioPago' headerText='Medio Pago' width=150></e-column>
                  <e-column field='Titular' headerText='Titular' width=100></e-column>
                  <e-column field='Cuit' headerText='CUIT' width=100></e-column>
                  <e-column field='Banco' headerText='Banco' width=100></e-column>
                  <e-column field='CodigoUnico' headerText='CBU/CVU' width=100></e-column>
                  <e-column field='Alias' headerText='Alias' width=100></e-column>
                  <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

        </ng-container>

      </ng-container>

      <!-- SALDOS DE CUENTAS -->
      <ng-container *ngIf="item != null && item.Id > 0 && canViewSaldos">

        <br/>
        
        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">monetization_on</mat-icon> Resumen de Saldos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="isSaldosSearching">
            <mat-label>Buscando...</mat-label>
          </div>

          <ng-container *ngIf="!isSaldosSearching">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="saldosList == null || saldosList.length == 0" >
              <mat-label>No hay saldos para mostrar.</mat-label>
            </div>

            <ng-container *ngIf="saldosList != null && saldosList.length > 0">

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;" *ngFor="let saldo of saldosList" >

                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label>
                        <b>Saldo Total</b>:
                        <span style="margin-left: 5px;" [ngStyle]="{ color: (saldo.SaldoTotal < 0) ? 'indianred' : 'black' }">{{saldo.Moneda}} {{saldo.SaldoTotal | number: '1.2-2'}}</span>
                      </mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo A Favor</b>: {{saldo.Moneda}} {{saldo.SaldoAFavor | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo Deudor</b>: {{saldo.Moneda}} {{saldo.SaldoDeudor | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo Vencido</b>: {{saldo.Moneda}} {{saldo.SaldoVencido | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </div>

            </ng-container>

          </ng-container>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isProcessing()" color="secondary" class="zb-button">
        {{isDeleting ? 'Eliminando...' : 'Eliminar' }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>